export default "__VITE_ASSET__JBffUKD8__"